import * as React from 'react';

import { useAssessmentContext } from '../../context';
import IAssessmentElement from '../../models/IAssessmentElement';
import { IValidatorConfig, IValidatorResult } from '../../models/IValidator';
import useQuestionManager from '../../plugins/useQuestionManager';
import CheckList from '../inputs/CheckList';

interface IProps 
{
	question: IAssessmentElement,
	onValidatorResultChanged?(validatorResult: IValidatorResult): void,
	onResetValidation?(parentElement: IAssessmentElement | null): void,
	validatorConfig?: IValidatorConfig
}

export function CheckListInput(props: IProps) 
{
	const assessmentContext = useAssessmentContext();
	const questionManager = useQuestionManager();
	const [answerValues, setAnswerValues] = React.useState<string[]>(assessmentContext.pageAnswers.filter(x => x.id == props.question.id)[0]?.value ?? []);

	// Sync with external updates from Redux (e.g., address lookup population)
	React.useEffect(() => 
	{
		const externalAnswers = assessmentContext.pageAnswers.filter(
			x => x.id == props.question.id
		)[0]?.value ?? [];

		setAnswerValues(externalAnswers);
	}, [assessmentContext.pageAnswers, props.question.id]);

	const onOptionCheck = (optionValue: string) => 
	{
		let newAnswerValues = [...answerValues];
		if (isOptionSelected(optionValue))
			newAnswerValues = newAnswerValues.filter(i => i !== optionValue); // remove
		else
			newAnswerValues = [...answerValues, optionValue]; // add

		newAnswerValues = newAnswerValues.filter((value, index, array) => array.indexOf(value) === index); // distinct

		setAnswerValues(newAnswerValues)
		questionManager.updateAnswerValue(props.question.id, newAnswerValues);

		if (props.onResetValidation && props.question.hasConditionalChildren)
			props.onResetValidation(props.question);
	};

	const isOptionSelected = (optionValue: string): boolean =>
		((answerValues.filter(a => a === optionValue).length ?? 0) > 0)

	return <CheckList
		onValidatorResultChanged={props.onValidatorResultChanged}
		validator={{
			validatorRules: questionManager.getQuestionValidatorRules(props.question),
			config: props.validatorConfig
		}}
		value={answerValues[0] ?? ''}
		answerValue={answerValues}
		options={props.question.options ?? []}
		onOptionCheck={onOptionCheck}
		isOptionSelected={isOptionSelected} />
}

export default CheckListInput;
